import httpr from "lib/httpRequest";

const jwt = require("jwt-simple");
const jwtSecret = "sPvy5R1i6plu0FS2^$zvfobpTf&J2E3FOMBD!Qspi#bkjXej!2";

/**
 * Decodes a JWT Token from request token
 * @param token
 */
export function getDecoded(token) {
  return new Promise((resolve, reject) => {
    resolve(jwt.decode(token, jwtSecret));
  });
}

export default function GetMemberInfo(token) {
  return new Promise((resolve, reject) => {
    const fetch = httpr(token);
    fetch
      .get("/auth/decode")
      .then(results => {
        resolve(results.data);
      })
      .catch(e => {
        console.log(e);
        resolve(null);
      });
  });
}

// Called on Login Button Press
export function MemberLogin(email, password) {
  return new Promise((resolve, reject) => {
    const fetch = httpr();
    fetch
      .post("/auth/login", { email, password })
      .then(results => {
        const { token } = results.data;
        if (token !== null && token !== undefined) {
          localStorage.setItem("token", token);
          resolve(token);
        } else { 
          console.log("token null");
          
          // resolve(results)
        }
      })
      .catch(err => {
        console.log("Error on Login: ", err.message);
        
        resolve(null);
      });
  });
}

// UNUSED, UserProfile component calls backend directly /api/members/create/
export function CreateMember(email, password) {
  return new Promise((resolve, reject) => {
    const fetch = httpr();
    fetch
      .post("/auth/login", { email, password })
      .then(results => {
        const { token } = results.data;

        if (token !== null && token !== undefined) {
          localStorage.setItem("token", token);
          resolve(token);
        }
      })
      .catch(e => {
        console.log(e);
        resolve(null);
      });
  });
}



// WEBPACK FOOTER //
// ./src/actions/MemberAction.jsx